// extracted by mini-css-extract-plugin
module.exports = {"ArticleAction":"ArticleAction_ArticleAction__1P31P","TooltipWrapper":"ArticleAction_TooltipWrapper__e75ST","TooltipText":"ArticleAction_TooltipText__3KvLU"};